<!--eslint-disable vue/no-v-text-v-html-on-component-->
<template>
  <iColumn
    :width="fullTextOptionsAttributes.width"
    :height="fullTextOptionsAttributes.height"
    :min-width="fullTextOptionsAttributes.minWith"
    :max-width="fullTextOptionsAttributes.maxWith"
  >
    <iRichText
      v-if="(editable || hasTextContent) && ((editMode && isEditable) || (hasTextContent && !editMode && isEditable))"
      ref="richTextElement"
      :model-value="initialValue"
      :handle-link-modal-open="handleLinkModalOpen"
      prevent-new-line-on-shift-enter
      :placeholder="editMode ? placeholderText : ''"
      :preview="previewMode"
      :show-toolbar="false"
      :show-bubble-menu="true"
      :tools-to-disable="['text-align', 'bullet-list']"
      :style-overrides="{
        borderWidth: 'none',
        borderRadius: 'none',
        paddingLeft: spacingStyleOverrides.paddingLeft,
        paddingRight: spacingStyleOverrides.paddingRight,
        paddingTop: spacingStyleOverrides.paddingTop,
        paddingBottom: spacingStyleOverrides.paddingBottom,
        marginLeft: spacingStyleOverrides.marginLeft,
        marginRight: spacingStyleOverrides.marginRight,
        marginTop: spacingStyleOverrides.marginTop,
        marginBottom: spacingStyleOverrides.marginBottom,
        backgroundColor: fullTextOptionsAttributes.textStyleOverrides.backgroundColor,
        hoverBackgroundColor: fullTextOptionsAttributes.textStyleOverrides.hoverBackgroundColor,
        boxShadow: fullTextOptionsAttributes.textStyleOverrides.boxShadow,
        boxShadowHover: fullTextOptionsAttributes.textStyleOverrides.boxShadowHover,
        textShadow: fullTextOptionsAttributes.textStyleOverrides.textShadow,
        textShadowHover: fullTextOptionsAttributes.textStyleOverrides.textShadowHover,
      }"
      :border-top="myBorderSides.top"
      :border-bottom="myBorderSides.bottom"
      :border-left="myBorderSides.left"
      :border-right="myBorderSides.right"
      v-bind="textOnlyAttributes"
      :class="{'clickable-text': hasClickValue}"
      :style="clickableStyle"
      @click="handleClick($event)"
      @blur="handleBlur"
      @keydown.enter.stop.prevent="handleEnter"
      @update:model-value="handleTextOptionUpdate($event)"
    />
    <iText
      v-else-if="(editMode && isEditable) || (hasTextContent && !editMode && isEditable)"
      v-bind="fullTextOptionsAttributes"
      :border-top="myBorderSides.top"
      :border-bottom="myBorderSides.bottom"
      :border-left="myBorderSides.left"
      :border-right="myBorderSides.right"
      :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
      :style="[!initialValueText ? {opacity: 0.5} : null, clickableStyle]"
      :class="{'clickable-text': hasClickValue}"

      @click="handleClick($event)"
    >
      {{ initialValueText || placeholderText }}
    </iText>
    <iText
      v-else-if="!isEditable && shouldShowText"
      v-bind="fullTextOptionsAttributes"
      :border-top="myBorderSides.top"
      :border-bottom="myBorderSides.bottom"
      :border-left="myBorderSides.left"
      :border-right="myBorderSides.right"
      :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
      :style="[!hasTextValue && editMode ? {opacity: 0.5} : null, clickableStyle]"
      :class="{'clickable-text': hasClickValue}"

      @click="handleClickAction"
    >
      {{ displayText }}
    </iText>
    <teleport v-if="showLinkModal" to="body">
      <RichTextDestinationPickerModal
        :show="showLinkModal"
        :original-link-value="originalLinkData.linkValue"
        :link-data="linkData"
        :publication-id="useFanPublicationStore().publicationId"
        :rich-text-ref="$refs.richTextElement"
        @close="handleLinkModalClose"
        @update="linkData = {...linkData, ...$event}"
      />
    </teleport>
  </iColumn>
</template>

<script>

import {
  BrandedTextElementMixin,
} from "%/dynamic-component-editor/standard-elements/text-element/branded-text-element-mixin";
import useFanPublicationStore from "%/dynamic-component-editor/stores/fan-publication-store";
import RichTextDestinationPickerModal from "%/dynamic-component-editor/components/RichTextDestinationPickerModal.vue";
import BrandedTextOptions from "%/dynamic-component-editor/bundles/branded-text-options";

export default {
  name: "BrandedTextElement",
  components: { RichTextDestinationPickerModal },
  mixins: [BrandedTextElementMixin],
  methods: { useFanPublicationStore },
  elementPanelSettings: {
    displayName: "Text",
    displayIcon: "text",
    elementType: "element",
    elementGroup: "general",
  },
  hidden: true,
  optionBundles: [
    new BrandedTextOptions({
      "default.text-style-option": "text",
    }),
  ],
};
</script>

<style lang="scss" scoped>
.clickable-text {
  cursor: pointer !important;
}
</style>
